import React, { useState } from "react";
import {BUTTON_BLUE_GRADIENT} from "../../../constants/colors";

export default function SplitScreenSelector({ id, screen1Label, screen1Ref, screen2Label, screen2Ref, displayFlag }) {

  const [hover, setHover] = useState(null);

  const thisContainer = {
    display: displayFlag,
    position: "fixed",
    top: "10px",
    left: "calc(50% - 250px)",
    zIndex: "20",
    flexDirection: "column"
  };

  const primaryContainer =
  {
      display: "flex",
      width: "500px",
      height: "42px",

	  background:
	      "rgba(10, 18, 27, 0.62)",

	  backdropFilter:
	      "blur(14px)",

	  WebkitBackdropFilter:
	      "blur(14px)",

      border:
          "1px solid rgba(255,255,255,0.14)",

      borderBottom:
          "2px solid #32aee4",

      borderRadius:
          0,

      alignItems:
          "center",

      justifyContent:
          "space-between",

      boxShadow:
          "0 8px 24px rgba(0,0,0,0.24)"
  };

  const baseLabel =
  {
      display:
          "flex",

      width:
          "33%",

      height:
          "100%",

      alignItems:
          "center",

      justifyContent:
          "center",

      color:
          "rgba(255,255,255,0.82)",

      fontSize:
          "14px",

      fontWeight:
          "500",

      cursor:
          "pointer",

      borderRight:
          "1px solid rgba(255,255,255,0.10)",

      transition:
          "all 0.25s ease"
  };

  const glowStyle =
  {
      color:
          "#ffffff",

      background:
          "rgba(50,174,228,0.16)",

      boxShadow:
          "inset 0 -2px 0 #32aee4"
  };

  const splitLabel = {
    ...baseLabel,
    borderRight: "none"
  };

  const goSplitLeft = () => {
    screen1Ref.current.style.width = "100%";
    screen2Ref.current.style.width = "0%";
  };

  const goSplitRight = () => {
    screen1Ref.current.style.width = "0%";
    screen2Ref.current.style.width = "100%";
  };

  const goSplit50 = () => {
    screen1Ref.current.style.width = "50%";
    screen2Ref.current.style.width = "50%";
  };

  return (
    <div style={thisContainer}>
      <div style={primaryContainer}>

        {/* LEFT */}
        <div
          style={{ ...baseLabel, ...(hover === "left" ? glowStyle : {}) }}
          onMouseEnter={() => setHover("left")}
          onMouseLeave={() => setHover(null)}
          onClick={goSplitLeft}
        >
          {screen1Label}
        </div>

        {/* RIGHT */}
        <div
          style={{ ...baseLabel, ...(hover === "right" ? glowStyle : {}) }}
          onMouseEnter={() => setHover("right")}
          onMouseLeave={() => setHover(null)}
          onClick={goSplitRight}
        >
          {screen2Label}
        </div>

        {/* SPLIT */}
        <div
          style={{ ...splitLabel, ...(hover === "split" ? glowStyle : {}) }}
          onMouseEnter={() => setHover("split")}
          onMouseLeave={() => setHover(null)}
          onClick={goSplit50}
        >
          Split Screen
        </div>

      </div>
    </div>
  );
}
